webpackJsonp([14,39,40,41,42],{

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1231);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("b8b616a2", content, true, {});

/***/ }),

/***/ 1231:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".native .footer-nav-inner[data-v-8ac7d058]{margin:0 auto;max-width:960px}.native .footer .nav-list[data-v-8ac7d058]{margin:0}.native .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child{border-top:1px solid #ccc}.native .footer .nav-item[data-v-8ac7d058]{border-bottom:1px solid #ccc;padding:.25em 1em}.native .footer .nav-item-a[data-v-8ac7d058]{display:block;margin:0 auto;max-width:400px;position:relative;font-weight:700;line-height:2.75}.native .footer .nav-item-a .fa[data-v-8ac7d058]{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}.native .footer .nav-sub-item[data-v-8ac7d058]{display:none}.native .footer .nav-sub-item-a[data-v-8ac7d058]{display:block;margin:0 auto;max-width:400px;line-height:2.75}.native .footer-info[data-v-8ac7d058]{padding:2em 1em}.native .footer-info-inner[data-v-8ac7d058]{margin:auto;max-width:960px}.native .footer-info-a[data-v-8ac7d058]{margin-bottom:1em;display:block}.native .footer-info-p[data-v-8ac7d058]{margin:0;line-height:1.75}.native .footer-info-links[data-v-8ac7d058]{padding:1em 0}.native .footer-info-link[data-v-8ac7d058]{margin:1em auto;padding:.5em .75em;max-width:16em;display:block;text-align:center;border-width:1px;border-style:solid}.native .footer-info-sns[data-v-8ac7d058]{margin:0 .5em;font-size:2em}.native .footer-copyright[data-v-8ac7d058]{padding:1em;color:#fff}.native .footer-copyright-p[data-v-8ac7d058]{margin:auto;max-width:960px;font-size:.8em;text-align:center}@media (min-width:768px){.native .footer-nav[data-v-8ac7d058]{padding:2em}.native .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child{border-top:none}.native .footer .nav-item[data-v-8ac7d058]{border:none;padding:.25em 0}.native .footer .nav-item-a[data-v-8ac7d058]{padding-right:1em;line-height:2}.native .footer .nav-item-a .fa[data-v-8ac7d058]{display:none}.native .footer .nav-sub-item[data-v-8ac7d058]{display:block;padding:.25em 0}.native .footer .nav-sub-item-a[data-v-8ac7d058]{padding-right:1em;line-height:2}.native .footer-info[data-v-8ac7d058]{padding:2em}.native .footer-copyright-p[data-v-8ac7d058]{text-align:right}}@media (min-width:1025px){.native .footer-info-link[data-v-8ac7d058]:hover{-webkit-transition:all .15s;transition:all .15s}.native .footer-info-sns[data-v-8ac7d058]{margin:0 .3em}.native .footer-info-sns[data-v-8ac7d058]:hover{-webkit-animation:pop-data-v-8ac7d058 .45s;animation:pop-data-v-8ac7d058 .45s}.native .footer-info-sns .fa[data-v-8ac7d058]{padding:0 .3em}}.desktop .footer-nav-inner[data-v-8ac7d058],.smartphone .footer-nav-inner[data-v-8ac7d058],.tablet .footer-nav-inner[data-v-8ac7d058]{margin:0 auto;max-width:960px}.desktop .footer .nav-list[data-v-8ac7d058],.smartphone .footer .nav-list[data-v-8ac7d058],.tablet .footer .nav-list[data-v-8ac7d058]{margin:0}.desktop .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child,.smartphone .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child,.tablet .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child{border-top:1px solid #ccc}.desktop .footer .nav-item[data-v-8ac7d058],.smartphone .footer .nav-item[data-v-8ac7d058],.tablet .footer .nav-item[data-v-8ac7d058]{border-bottom:1px solid #ccc;padding:.25em 1em}.desktop .footer .nav-item-a[data-v-8ac7d058],.smartphone .footer .nav-item-a[data-v-8ac7d058],.tablet .footer .nav-item-a[data-v-8ac7d058]{display:block;margin:0 auto;max-width:400px;position:relative;font-weight:700;line-height:2.75}.desktop .footer .nav-item-a .fa[data-v-8ac7d058],.smartphone .footer .nav-item-a .fa[data-v-8ac7d058],.tablet .footer .nav-item-a .fa[data-v-8ac7d058]{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}.desktop .footer .nav-sub-item[data-v-8ac7d058],.smartphone .footer .nav-sub-item[data-v-8ac7d058],.tablet .footer .nav-sub-item[data-v-8ac7d058]{display:none}.desktop .footer .nav-sub-item-a[data-v-8ac7d058],.smartphone .footer .nav-sub-item-a[data-v-8ac7d058],.tablet .footer .nav-sub-item-a[data-v-8ac7d058]{display:block;margin:0 auto;max-width:400px;line-height:2.75}.desktop .footer-info[data-v-8ac7d058],.smartphone .footer-info[data-v-8ac7d058],.tablet .footer-info[data-v-8ac7d058]{padding:2em 1em}.desktop .footer-info-inner[data-v-8ac7d058],.smartphone .footer-info-inner[data-v-8ac7d058],.tablet .footer-info-inner[data-v-8ac7d058]{margin:auto;max-width:960px}.desktop .footer-info-a[data-v-8ac7d058],.smartphone .footer-info-a[data-v-8ac7d058],.tablet .footer-info-a[data-v-8ac7d058]{margin-bottom:1em;display:block}.desktop .footer-info-p[data-v-8ac7d058],.smartphone .footer-info-p[data-v-8ac7d058],.tablet .footer-info-p[data-v-8ac7d058]{margin:0;line-height:1.75}.desktop .footer-info-links[data-v-8ac7d058],.smartphone .footer-info-links[data-v-8ac7d058],.tablet .footer-info-links[data-v-8ac7d058]{padding:1em 0}.desktop .footer-info-link[data-v-8ac7d058],.smartphone .footer-info-link[data-v-8ac7d058],.tablet .footer-info-link[data-v-8ac7d058]{margin:1em auto;padding:.5em .75em;max-width:16em;display:block;text-align:center;border-width:1px;border-style:solid}.desktop .footer-info-sns[data-v-8ac7d058],.smartphone .footer-info-sns[data-v-8ac7d058],.tablet .footer-info-sns[data-v-8ac7d058]{margin:0 .5em;font-size:2em}.desktop .footer-copyright[data-v-8ac7d058],.smartphone .footer-copyright[data-v-8ac7d058],.tablet .footer-copyright[data-v-8ac7d058]{padding:1em;color:#fff}.desktop .footer-copyright-p[data-v-8ac7d058],.smartphone .footer-copyright-p[data-v-8ac7d058],.tablet .footer-copyright-p[data-v-8ac7d058]{margin:auto;max-width:960px;font-size:.8em;text-align:center}@-webkit-keyframes pop-data-v-8ac7d058{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(-.3em);transform:translateY(-.3em)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes pop-data-v-8ac7d058{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(-.3em);transform:translateY(-.3em)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.desktop .footer-nav[data-v-8ac7d058],.tablet .footer-nav[data-v-8ac7d058]{padding:2em}.desktop .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child,.tablet .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child{border-top:none}.desktop .footer .nav-item[data-v-8ac7d058],.tablet .footer .nav-item[data-v-8ac7d058]{border:none;padding:.25em 0}.desktop .footer .nav-item-a[data-v-8ac7d058],.tablet .footer .nav-item-a[data-v-8ac7d058]{padding-right:1em;line-height:2}.desktop .footer .nav-item-a .fa[data-v-8ac7d058],.tablet .footer .nav-item-a .fa[data-v-8ac7d058]{display:none}.desktop .footer .nav-sub-item[data-v-8ac7d058],.tablet .footer .nav-sub-item[data-v-8ac7d058]{display:block;padding:.25em 0}.desktop .footer .nav-sub-item-a[data-v-8ac7d058],.tablet .footer .nav-sub-item-a[data-v-8ac7d058]{padding-right:1em;line-height:2}.desktop .footer-info[data-v-8ac7d058],.tablet .footer-info[data-v-8ac7d058]{padding:2em}.desktop .footer-copyright-p[data-v-8ac7d058],.tablet .footer-copyright-p[data-v-8ac7d058]{text-align:right}.desktop .footer-info-link[data-v-8ac7d058]:hover{-webkit-transition:all .15s;transition:all .15s}.desktop .footer-info-sns[data-v-8ac7d058]{margin:0 .3em}.desktop .footer-info-sns[data-v-8ac7d058]:hover{-webkit-animation:pop-data-v-8ac7d058 .45s;animation:pop-data-v-8ac7d058 .45s}.desktop .footer-info-sns .fa[data-v-8ac7d058]{padding:0 .3em}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/footer/FooterCompany1/FooterCompany1.vue"],"names":[],"mappings":"AAmCA,2CACI,cAAe,AACf,eAAiB,CACpB,AACD,2CACI,QAAU,CACb,AACD,6EACM,yBAA2B,CAChC,AACD,2CACI,6BAA8B,AAC9B,iBAAmB,CACtB,AACD,6CACM,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,gBAAkB,AAClB,gBAAkB,CACvB,AACD,iDACQ,YAAa,AACb,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,OAAS,CAChB,AACD,+CACI,YAAc,CACjB,AACD,iDACM,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,gBAAkB,CACvB,AACD,sCACI,eAAiB,CACpB,AACD,4CACM,YAAa,AACb,eAAiB,CACtB,AACD,wCACM,kBAAmB,AACnB,aAAe,CACpB,AACD,wCACM,SAAU,AACV,gBAAkB,CACvB,AACD,4CACM,aAAe,CACpB,AACD,2CACM,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CACzB,AACD,0CACM,cAAe,AACf,aAAe,CACpB,AACD,2CACI,YAAa,AACb,UAAY,CACf,AACD,6CACM,YAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACxB,AA6BD,yBAmBA,qCACQ,WAAa,CACpB,AACD,6EACQ,eAAiB,CACxB,AACD,2CACQ,YAAa,AACb,eAAiB,CACxB,AACD,6CACU,kBAAmB,AACnB,aAAe,CACxB,AACD,iDACY,YAAc,CACzB,AACD,+CACQ,cAAe,AACf,eAAiB,CACxB,AACD,iDACU,kBAAmB,AACnB,aAAe,CACxB,AACD,sCACQ,WAAa,CACpB,AACD,6CACQ,gBAAkB,CACzB,CACA,AACD,0BAmBA,iDACQ,4BAA8B,AAC9B,mBAAsB,CAC7B,AACD,0CACQ,aAAe,CACtB,AACD,gDACU,2CAA6C,AAC7C,kCAAqC,CAC9C,AACD,8CACU,cAAgB,CACzB,CACA,AAqBD,sIAGI,cAAe,AACf,eAAiB,CACpB,AACD,sIAGI,QAAU,CACb,AACD,4OAGM,yBAA2B,CAChC,AACD,sIAGI,6BAA8B,AAC9B,iBAAmB,CACtB,AACD,4IAGM,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,gBAAkB,AAClB,gBAAkB,CACvB,AACD,wJAGQ,YAAa,AACb,UAAW,AACX,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,OAAS,CAChB,AACD,kJAGI,YAAc,CACjB,AACD,wJAGM,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,gBAAkB,CACvB,AACD,uHAGI,eAAiB,CACpB,AACD,yIAGM,YAAa,AACb,eAAiB,CACtB,AACD,6HAGM,kBAAmB,AACnB,aAAe,CACpB,AACD,6HAGM,SAAU,AACV,gBAAkB,CACvB,AACD,yIAGM,aAAe,CACpB,AACD,sIAGM,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CACzB,AACD,mIAGM,cAAe,AACf,aAAe,CACpB,AACD,sIAGI,YAAa,AACb,UAAY,CACf,AACD,4IAGM,YAAa,AACb,gBAAiB,AACjB,eAAgB,AAChB,iBAAmB,CACxB,AACD,uCACA,GACI,gCAAiC,AACjC,uBAAyB,CAC5B,AACD,IACI,oCAAsC,AACtC,2BAA8B,CACjC,AACD,GACI,gCAAiC,AACjC,uBAAyB,CAC5B,CACA,AACD,+BACA,GACI,gCAAiC,AACjC,uBAAyB,CAC5B,AACD,IACI,oCAAsC,AACtC,2BAA8B,CACjC,AACD,GACI,gCAAiC,AACjC,uBAAyB,CAC5B,CACA,AAoBD,2EAEI,WAAa,CAChB,AACD,2JAEI,eAAiB,CACpB,AACD,uFAEI,YAAa,AACb,eAAiB,CACpB,AACD,2FAEM,kBAAmB,AACnB,aAAe,CACpB,AACD,mGAEQ,YAAc,CACrB,AACD,+FAEI,cAAe,AACf,eAAiB,CACpB,AACD,mGAEM,kBAAmB,AACnB,aAAe,CACpB,AACD,6EAEI,WAAa,CAChB,AACD,2FAEI,gBAAkB,CACrB,AAmBD,kDACI,4BAA8B,AAC9B,mBAAsB,CACzB,AACD,2CACI,aAAe,CAClB,AACD,iDACM,2CAA6C,AAC7C,kCAAqC,CAC1C,AACD,+CACM,cAAgB,CACrB","file":"FooterCompany1.vue","sourcesContent":["\n.native[data-v-8ac7d058] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.native .footer-nav-inner[data-v-8ac7d058] {\n    margin: 0 auto;\n    max-width: 960px;\n}\n.native .footer .nav-list[data-v-8ac7d058] {\n    margin: 0;\n}\n.native .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child {\n      border-top: 1px solid #ccc;\n}\n.native .footer .nav-item[data-v-8ac7d058] {\n    border-bottom: 1px solid #ccc;\n    padding: .25em 1em;\n}\n.native .footer .nav-item-a[data-v-8ac7d058] {\n      display: block;\n      margin: 0 auto;\n      max-width: 400px;\n      position: relative;\n      font-weight: bold;\n      line-height: 2.75;\n}\n.native .footer .nav-item-a .fa[data-v-8ac7d058] {\n        margin: auto;\n        width: 1em;\n        height: 1em;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 0;\n}\n.native .footer .nav-sub-item[data-v-8ac7d058] {\n    display: none;\n}\n.native .footer .nav-sub-item-a[data-v-8ac7d058] {\n      display: block;\n      margin: 0 auto;\n      max-width: 400px;\n      line-height: 2.75;\n}\n.native .footer-info[data-v-8ac7d058] {\n    padding: 2em 1em;\n}\n.native .footer-info-inner[data-v-8ac7d058] {\n      margin: auto;\n      max-width: 960px;\n}\n.native .footer-info-a[data-v-8ac7d058] {\n      margin-bottom: 1em;\n      display: block;\n}\n.native .footer-info-p[data-v-8ac7d058] {\n      margin: 0;\n      line-height: 1.75;\n}\n.native .footer-info-links[data-v-8ac7d058] {\n      padding: 1em 0;\n}\n.native .footer-info-link[data-v-8ac7d058] {\n      margin: 1em auto;\n      padding: .5em .75em;\n      max-width: 16em;\n      display: block;\n      text-align: center;\n      border-width: 1px;\n      border-style: solid;\n}\n.native .footer-info-sns[data-v-8ac7d058] {\n      margin: 0 .5em;\n      font-size: 2em;\n}\n.native .footer-copyright[data-v-8ac7d058] {\n    padding: 1em;\n    color: #fff;\n}\n.native .footer-copyright-p[data-v-8ac7d058] {\n      margin: auto;\n      max-width: 960px;\n      font-size: .8em;\n      text-align: center;\n}\n@-webkit-keyframes pop-data-v-8ac7d058 {\n0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(-0.3em);\n    transform: translateY(-0.3em);\n}\n100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n}\n@keyframes pop-data-v-8ac7d058 {\n0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(-0.3em);\n    transform: translateY(-0.3em);\n}\n100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n}\n@media (min-width: 768px) {\n.native[data-v-8ac7d058] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .footer-nav[data-v-8ac7d058] {\n        padding: 2em;\n}\n.native .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child {\n        border-top: none;\n}\n.native .footer .nav-item[data-v-8ac7d058] {\n        border: none;\n        padding: .25em 0;\n}\n.native .footer .nav-item-a[data-v-8ac7d058] {\n          padding-right: 1em;\n          line-height: 2;\n}\n.native .footer .nav-item-a .fa[data-v-8ac7d058] {\n            display: none;\n}\n.native .footer .nav-sub-item[data-v-8ac7d058] {\n        display: block;\n        padding: .25em 0;\n}\n.native .footer .nav-sub-item-a[data-v-8ac7d058] {\n          padding-right: 1em;\n          line-height: 2;\n}\n.native .footer-info[data-v-8ac7d058] {\n        padding: 2em;\n}\n.native .footer-copyright-p[data-v-8ac7d058] {\n        text-align: right;\n}\n}\n@media (min-width: 1025px) {\n.native[data-v-8ac7d058] {\n      /**\n *\n * Layout\n *\n */\n      /**\n * Columns\n */\n      /**\n * Component\n */\n      /**\n *\n * Application specific variables\n *\n */\n}\n.native .footer-info-link[data-v-8ac7d058]:hover {\n        -webkit-transition: all 150ms;\n        transition: all 150ms;\n}\n.native .footer-info-sns[data-v-8ac7d058] {\n        margin: 0 .3em;\n}\n.native .footer-info-sns[data-v-8ac7d058]:hover {\n          -webkit-animation: pop-data-v-8ac7d058 450ms;\n          animation: pop-data-v-8ac7d058 450ms;\n}\n.native .footer-info-sns .fa[data-v-8ac7d058] {\n          padding: 0 .3em;\n}\n}\n.smartphone[data-v-8ac7d058],\n.tablet[data-v-8ac7d058],\n.desktop[data-v-8ac7d058] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.smartphone .footer-nav-inner[data-v-8ac7d058],\n  .tablet .footer-nav-inner[data-v-8ac7d058],\n  .desktop .footer-nav-inner[data-v-8ac7d058] {\n    margin: 0 auto;\n    max-width: 960px;\n}\n.smartphone .footer .nav-list[data-v-8ac7d058],\n  .tablet .footer .nav-list[data-v-8ac7d058],\n  .desktop .footer .nav-list[data-v-8ac7d058] {\n    margin: 0;\n}\n.smartphone .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child,\n    .tablet .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child,\n    .desktop .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child {\n      border-top: 1px solid #ccc;\n}\n.smartphone .footer .nav-item[data-v-8ac7d058],\n  .tablet .footer .nav-item[data-v-8ac7d058],\n  .desktop .footer .nav-item[data-v-8ac7d058] {\n    border-bottom: 1px solid #ccc;\n    padding: .25em 1em;\n}\n.smartphone .footer .nav-item-a[data-v-8ac7d058],\n    .tablet .footer .nav-item-a[data-v-8ac7d058],\n    .desktop .footer .nav-item-a[data-v-8ac7d058] {\n      display: block;\n      margin: 0 auto;\n      max-width: 400px;\n      position: relative;\n      font-weight: bold;\n      line-height: 2.75;\n}\n.smartphone .footer .nav-item-a .fa[data-v-8ac7d058],\n      .tablet .footer .nav-item-a .fa[data-v-8ac7d058],\n      .desktop .footer .nav-item-a .fa[data-v-8ac7d058] {\n        margin: auto;\n        width: 1em;\n        height: 1em;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 0;\n}\n.smartphone .footer .nav-sub-item[data-v-8ac7d058],\n  .tablet .footer .nav-sub-item[data-v-8ac7d058],\n  .desktop .footer .nav-sub-item[data-v-8ac7d058] {\n    display: none;\n}\n.smartphone .footer .nav-sub-item-a[data-v-8ac7d058],\n    .tablet .footer .nav-sub-item-a[data-v-8ac7d058],\n    .desktop .footer .nav-sub-item-a[data-v-8ac7d058] {\n      display: block;\n      margin: 0 auto;\n      max-width: 400px;\n      line-height: 2.75;\n}\n.smartphone .footer-info[data-v-8ac7d058],\n  .tablet .footer-info[data-v-8ac7d058],\n  .desktop .footer-info[data-v-8ac7d058] {\n    padding: 2em 1em;\n}\n.smartphone .footer-info-inner[data-v-8ac7d058],\n    .tablet .footer-info-inner[data-v-8ac7d058],\n    .desktop .footer-info-inner[data-v-8ac7d058] {\n      margin: auto;\n      max-width: 960px;\n}\n.smartphone .footer-info-a[data-v-8ac7d058],\n    .tablet .footer-info-a[data-v-8ac7d058],\n    .desktop .footer-info-a[data-v-8ac7d058] {\n      margin-bottom: 1em;\n      display: block;\n}\n.smartphone .footer-info-p[data-v-8ac7d058],\n    .tablet .footer-info-p[data-v-8ac7d058],\n    .desktop .footer-info-p[data-v-8ac7d058] {\n      margin: 0;\n      line-height: 1.75;\n}\n.smartphone .footer-info-links[data-v-8ac7d058],\n    .tablet .footer-info-links[data-v-8ac7d058],\n    .desktop .footer-info-links[data-v-8ac7d058] {\n      padding: 1em 0;\n}\n.smartphone .footer-info-link[data-v-8ac7d058],\n    .tablet .footer-info-link[data-v-8ac7d058],\n    .desktop .footer-info-link[data-v-8ac7d058] {\n      margin: 1em auto;\n      padding: .5em .75em;\n      max-width: 16em;\n      display: block;\n      text-align: center;\n      border-width: 1px;\n      border-style: solid;\n}\n.smartphone .footer-info-sns[data-v-8ac7d058],\n    .tablet .footer-info-sns[data-v-8ac7d058],\n    .desktop .footer-info-sns[data-v-8ac7d058] {\n      margin: 0 .5em;\n      font-size: 2em;\n}\n.smartphone .footer-copyright[data-v-8ac7d058],\n  .tablet .footer-copyright[data-v-8ac7d058],\n  .desktop .footer-copyright[data-v-8ac7d058] {\n    padding: 1em;\n    color: #fff;\n}\n.smartphone .footer-copyright-p[data-v-8ac7d058],\n    .tablet .footer-copyright-p[data-v-8ac7d058],\n    .desktop .footer-copyright-p[data-v-8ac7d058] {\n      margin: auto;\n      max-width: 960px;\n      font-size: .8em;\n      text-align: center;\n}\n@-webkit-keyframes pop-data-v-8ac7d058 {\n0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(-0.3em);\n    transform: translateY(-0.3em);\n}\n100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n}\n@keyframes pop-data-v-8ac7d058 {\n0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n50% {\n    -webkit-transform: translateY(-0.3em);\n    transform: translateY(-0.3em);\n}\n100% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n}\n}\n.tablet[data-v-8ac7d058],\n.desktop[data-v-8ac7d058] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.tablet .footer-nav[data-v-8ac7d058],\n  .desktop .footer-nav[data-v-8ac7d058] {\n    padding: 2em;\n}\n.tablet .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child,\n  .desktop .footer .nav-list:first-child .nav-item[data-v-8ac7d058]:first-child {\n    border-top: none;\n}\n.tablet .footer .nav-item[data-v-8ac7d058],\n  .desktop .footer .nav-item[data-v-8ac7d058] {\n    border: none;\n    padding: .25em 0;\n}\n.tablet .footer .nav-item-a[data-v-8ac7d058],\n    .desktop .footer .nav-item-a[data-v-8ac7d058] {\n      padding-right: 1em;\n      line-height: 2;\n}\n.tablet .footer .nav-item-a .fa[data-v-8ac7d058],\n      .desktop .footer .nav-item-a .fa[data-v-8ac7d058] {\n        display: none;\n}\n.tablet .footer .nav-sub-item[data-v-8ac7d058],\n  .desktop .footer .nav-sub-item[data-v-8ac7d058] {\n    display: block;\n    padding: .25em 0;\n}\n.tablet .footer .nav-sub-item-a[data-v-8ac7d058],\n    .desktop .footer .nav-sub-item-a[data-v-8ac7d058] {\n      padding-right: 1em;\n      line-height: 2;\n}\n.tablet .footer-info[data-v-8ac7d058],\n  .desktop .footer-info[data-v-8ac7d058] {\n    padding: 2em;\n}\n.tablet .footer-copyright-p[data-v-8ac7d058],\n  .desktop .footer-copyright-p[data-v-8ac7d058] {\n    text-align: right;\n}\n.desktop[data-v-8ac7d058] {\n  /**\n *\n * Layout\n *\n */\n  /**\n * Columns\n */\n  /**\n * Component\n */\n  /**\n *\n * Application specific variables\n *\n */\n}\n.desktop .footer-info-link[data-v-8ac7d058]:hover {\n    -webkit-transition: all 150ms;\n    transition: all 150ms;\n}\n.desktop .footer-info-sns[data-v-8ac7d058] {\n    margin: 0 .3em;\n}\n.desktop .footer-info-sns[data-v-8ac7d058]:hover {\n      -webkit-animation: pop-data-v-8ac7d058 450ms;\n      animation: pop-data-v-8ac7d058 450ms;\n}\n.desktop .footer-info-sns .fa[data-v-8ac7d058] {\n      padding: 0 .3em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1232:
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(1233),
    isIterateeCall = __webpack_require__(1234),
    toInteger = __webpack_require__(1235);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */
function chunk(array, size, guard) {
  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
    size = 1;
  } else {
    size = nativeMax(toInteger(size), 0);
  }
  var length = array == null ? 0 : array.length;
  if (!length || size < 1) {
    return [];
  }
  var index = 0,
      resIndex = 0,
      result = Array(nativeCeil(length / size));

  while (index < length) {
    result[resIndex++] = baseSlice(array, index, (index += size));
  }
  return result;
}

module.exports = chunk;


/***/ }),

/***/ 1233:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 1234:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(603),
    isArrayLike = __webpack_require__(476),
    isIndex = __webpack_require__(626),
    isObject = __webpack_require__(457);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 1235:
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1236);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 1236:
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1237);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 1237:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(457),
    isSymbol = __webpack_require__(1238);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 1238:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(463),
    isObjectLike = __webpack_require__(465);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 1239:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./FooterCompany1.l.scss": 1240,
	"./FooterCompany1.m.scss": 1242,
	"./FooterCompany1.s.scss": 1244,
	"./FooterCompany1.scss": 1246
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1239;

/***/ }),

/***/ 1240:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1241);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1241:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".footer-info-link:hover{-webkit-transition:all .15s;transition:all .15s}.footer-info-sns{margin:0 .3em}.footer-info-sns:hover{-webkit-animation:pop .45s;animation:pop .45s}.footer-info-sns .fa{padding:0 .3em}", ""]);

// exports


/***/ }),

/***/ 1242:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1243);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1243:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".footer-nav{padding:2em}.footer .nav-list:first-child .nav-item:first-child{border-top:none}.footer .nav-item{border:none;padding:.25em 0}.footer .nav-item-a{padding-right:1em;line-height:2}.footer .nav-item-a .fa{display:none}.footer .nav-sub-item{display:block;padding:.25em 0}.footer .nav-sub-item-a{padding-right:1em;line-height:2}.footer-info{padding:2em}.footer-copyright-p{text-align:right}", ""]);

// exports


/***/ }),

/***/ 1244:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1245);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1245:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".footer-nav-inner{margin:0 auto;max-width:960px}.footer .nav-list{margin:0}.footer .nav-list:first-child .nav-item:first-child{border-top:1px solid #ccc}.footer .nav-item{border-bottom:1px solid #ccc;padding:.25em 1em}.footer .nav-item-a{display:block;margin:0 auto;max-width:400px;position:relative;font-weight:700;line-height:2.75}.footer .nav-item-a .fa{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}.footer .nav-sub-item{display:none}.footer .nav-sub-item-a{display:block;margin:0 auto;max-width:400px;line-height:2.75}.footer-info{padding:2em 1em}.footer-info-inner{margin:auto;max-width:960px}.footer-info-a{margin-bottom:1em;display:block}.footer-info-p{margin:0;line-height:1.75}.footer-info-links{padding:1em 0}.footer-info-link{margin:1em auto;padding:.5em .75em;max-width:16em;display:block;text-align:center;border-width:1px;border-style:solid}.footer-info-sns{margin:0 .5em;font-size:2em}.footer-copyright{padding:1em;color:#fff}.footer-copyright-p{margin:auto;max-width:960px;font-size:.8em;text-align:center}@-webkit-keyframes pop{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(-.3em);transform:translateY(-.3em)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes pop{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(-.3em);transform:translateY(-.3em)}to{-webkit-transform:translateY(0);transform:translateY(0)}}", ""]);

// exports


/***/ }),

/***/ 1246:
/***/ (function(module, exports, __webpack_require__) {

// css-to-string-loader: transforms styles from css-loader to a string output

// Get the styles
var styles = __webpack_require__(1247);

if (typeof styles === 'string') {
  // Return an existing string
  module.exports = styles;
} else {
  // Call the custom toString method from css-loader module
  module.exports = styles.toString();
}

/***/ }),

/***/ 1247:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(false);
// imports


// module
exports.push([module.i, ".footer-nav-inner{margin:0 auto;max-width:960px}.footer .nav-list{margin:0}.footer .nav-list:first-child .nav-item:first-child{border-top:1px solid #ccc}.footer .nav-item{border-bottom:1px solid #ccc;padding:.25em 1em}.footer .nav-item-a{display:block;margin:0 auto;max-width:400px;position:relative;font-weight:700;line-height:2.75}.footer .nav-item-a .fa{margin:auto;width:1em;height:1em;position:absolute;top:0;bottom:0;right:0}.footer .nav-sub-item{display:none}.footer .nav-sub-item-a{display:block;margin:0 auto;max-width:400px;line-height:2.75}.footer-info{padding:2em 1em}.footer-info-inner{margin:auto;max-width:960px}.footer-info-a{margin-bottom:1em;display:block}.footer-info-p{margin:0;line-height:1.75}.footer-info-links{padding:1em 0}.footer-info-link{margin:1em auto;padding:.5em .75em;max-width:16em;display:block;text-align:center;border-width:1px;border-style:solid}.footer-info-sns{margin:0 .5em;font-size:2em}.footer-copyright{padding:1em;color:#fff}.footer-copyright-p{margin:auto;max-width:960px;font-size:.8em;text-align:center}@-webkit-keyframes pop{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(-.3em);transform:translateY(-.3em)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes pop{0%{-webkit-transform:translateY(0);transform:translateY(0)}50%{-webkit-transform:translateY(-.3em);transform:translateY(-.3em)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@media (min-width:768px){.footer-nav{padding:2em}.footer .nav-list:first-child .nav-item:first-child{border-top:none}.footer .nav-item{border:none;padding:.25em 0}.footer .nav-item-a{padding-right:1em;line-height:2}.footer .nav-item-a .fa{display:none}.footer .nav-sub-item{display:block;padding:.25em 0}.footer .nav-sub-item-a{padding-right:1em;line-height:2}.footer-info{padding:2em}.footer-copyright-p{text-align:right}}@media (min-width:1025px){.footer-info-link:hover{-webkit-transition:all .15s;transition:all .15s}.footer-info-sns{margin:0 .3em}.footer-info-sns:hover{-webkit-animation:pop .45s;animation:pop .45s}.footer-info-sns .fa{padding:0 .3em}}", ""]);

// exports


/***/ }),

/***/ 1248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.contents)?[_c('div',{class:['component', _vm.previewSize],style:(_vm.hideAll ? 'display:none' : '')},[_c('div',{on:{"click":function($event){_vm.isEditing = !_vm.lock}}},[_c('div',{staticClass:"footer theme-base-bg-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('background-color', 'base') : '')},[_c('nav',{staticClass:"footer-nav theme-main-bg-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('background-color', 'main') : '')},[_c('div',{staticClass:"footer-nav-inner"},[_c('div',{class:['grid', 'grid-1-2-m', 'grid-1-' + _vm.chunksPages.length + '-l']},[_vm._l((_vm.chunksPages),function(chunk,i){return [_c('div',[_c('ul',{staticClass:"nav-list flex column"},[_vm._l((chunk),function(page,j){return [(+page.parent === 0)?[_c('li',{key:i * _vm.chunkLength + j,staticClass:"nav-item"},[_c('a',{staticClass:"nav-item-a"},[_vm._v(_vm._s(page.title.rendered)),_c('i',{staticClass:"fa fa-angle-right",attrs:{"aria-hidden":"true"}})])])]:[_c('li',{key:i * _vm.chunkLength + j,staticClass:"nav-sub-item"},[_c('a',{staticClass:"nav-sub-item-a"},[_vm._v(_vm._s(page.title.rendered))])])]]})],2)])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"footer-info"},[_c('div',{staticClass:"footer-info-inner flex column-reverse justify-between items-center row-m"},[_c('div',{staticClass:"footer-info-address"},[_c('a',{staticClass:"footer-info-a"},[(_vm.logo.src)?[_c('mimic-amp-img',{attrs:{"image":_vm.logo}})]:[_c('div',{staticStyle:{"color":"red"}},[_vm._v("Settingsでロゴを設定して選択してください。")])]],2),_vm._v(" "),_c('p',{staticClass:"footer-info-p"},[(_vm.fullAddress)?[_c('span',[_vm._v(_vm._s(_vm.fullAddress))])]:[_c('span',{staticStyle:{"color":"red"}},[_vm._v("Settingsで所在地を設定してください")])]],2),_vm._v(" "),_c('p',{staticClass:"footer-info-p"},[(_vm.contact.tel)?[_c('span',[_vm._v("TEL："+_vm._s(_vm.contact.tel))])]:[_c('span',{staticStyle:{"color":"red"}},[_vm._v("Settingsで電話番号を設定してください")])],_vm._v(" "),(_vm.contact.fax)?[_c('span',[_vm._v("FAX："+_vm._s(_vm.contact.fax))])]:_vm._e()],2),_vm._v(" "),_c('p',{staticClass:"footer-info-p"},[(_vm.contact.email)?[_c('span',[_vm._v("e-mail："+_vm._s(_vm.contact.email))])]:[_c('span',{staticStyle:{"color":"red"}},[_vm._v("Settingsでメールアドレスを設定してください")])]],2)]),_vm._v(" "),_c('div',{staticClass:"footer-info-links"},[_vm._l((_vm.contents.linkIds),function(id){return [_c('a',{staticClass:"footer-info-link theme-accent-color theme-accent-border-color theme-accent-bg-color-hover",style:(_vm.inPreview ? _vm.getThemeInlineStyle('color', 'accent') : '')},[_vm._v(_vm._s(_vm.getPageById(id).title.rendered))])]}),_vm._v(" "),_c('div',{staticClass:"footer-info-sns-wrapper flex justify-center items-center"},[(_vm.settings.facebook && _vm.settings.facebook.id)?[_vm._m(0)]:_vm._e(),_vm._v(" "),(_vm.settings.twitter && _vm.settings.twitter.owner)?[_vm._m(1)]:_vm._e(),_vm._v(" "),(_vm.settings.instagram && _vm.settings.instagram.id)?[_vm._m(2)]:_vm._e(),_vm._v(" "),(_vm.settings.youtube && _vm.settings.youtube.channelId)?[_vm._m(3)]:_vm._e()],2)],2)])]),_vm._v(" "),_c('div',{staticClass:"footer-copyright theme-accent-bg-color",style:(_vm.inPreview ? _vm.getThemeInlineStyle('background-color', 'accent') : '')},[_c('p',{staticClass:"footer-copyright-p"},[_vm._v("© "+_vm._s(_vm.owner)+" All Rights Reserved.")])])])])]),_vm._v(" "),_c('el-dialog',{attrs:{"width":"75%","title":"フッターコンポーネントのコンテンツを編集","visible":_vm.isEditing},on:{"update:visible":function($event){_vm.isEditing=$event}}},[_c('el-form',{attrs:{"model":_vm.contents}},[_c('el-form-item',{attrs:{"label":"リンクボタンの追加 (2つまで)","label-width":_vm.labelWidth}},[_c('select-links',{attrs:{"limit":2},model:{value:(_vm.contents.linkIds),callback:function ($$v) {_vm.$set(_vm.contents, "linkIds", $$v)},expression:"contents.linkIds"}})],1)],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('component-form-footer',{on:{"delete":function($event){_vm.deleteComponent()},"cancel":function($event){_vm.isEditing = false},"update":function($event){_vm.updateComponent()}}})],1)],1)]:_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"footer-info-sns"},[_c('i',{staticClass:"fa fa-facebook",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"footer-info-sns"},[_c('i',{staticClass:"fa fa-twitter",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"footer-info-sns"},[_c('i',{staticClass:"fa fa-instagram",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"footer-info-sns"},[_c('i',{staticClass:"fa fa-youtube",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__ = __webpack_require__(450);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e587aeb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ComponentFormFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e587aeb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ComponentFormFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__ = __webpack_require__(131);



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    'component-form-footer': __WEBPACK_IMPORTED_MODULE_1__components_forms_ComponentFormFooter__["default"]
  },
  data: function data() {
    return {
      name: this.$options.name,
      newPosition: this.index + 1,
      isEditing: false,
      extensions: []
    };
  },

  props: {
    index: { type: Number, default: null },
    bus: { type: Object, default: null },
    positionMax: { type: Number, default: null },
    component: { type: Object, default: null },
    components: { type: Array, default: null },
    hideAll: { type: Boolean, default: false },
    lock: { type: Boolean, default: false },
    previewSize: { type: String, default: 'native' },
    inPreview: { type: Boolean, default: false }
  },
  computed: {
    contents: {
      get: function get() {
        return this.component.contents;
      }
    },
    url: {
      get: function get() {
        return this.$store.getters['wordpress/account/url'];
      }
    },
    meta: {
      get: function get() {
        return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].components[this.component.id].meta;
      }
    },
    posts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/all'];
      }
    },
    publishedPosts: {
      get: function get() {
        return this.$store.getters['wordpress/posts/published'];
      }
    },
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    },
    media: {
      get: function get() {
        return this.$store.getters['wordpress/media/all'];
      }
    },
    themes: {
      get: function get() {
        return this.$store.getters['wordpress/themes/all'];
      }
    },
    settings: {
      get: function get() {
        return this.$store.getters['wordpress/settings/all'];
      }
    },
    sectionId: {
      get: function get() {
        return this.componentId(this);
      }
    },
    sectionClass: {
      get: function get() {
        return this.meta.file + ' ' + this.meta.file + '-' + this._uid + ' ' + (this.contents.bg.isCustom ? this.meta.file + '-' + this._uid + '-bg' : 'theme-base-bg-color') + ' slide';
      }
    },
    sectionClassArray: {
      get: function get() {
        return [this.meta.file, 'slide', 'theme-base-bg-color'];
      }
    },
    sectionStyle: {
      get: function get() {
        return this.contents.bg.isCustom ? 'background-color:' + this.contents.bg.color : '';
      }
    },
    containerClass: {
      get: function get() {
        return (this.contents.fullWidth ? '' : 'container') + (this.contents.padding.y ? ' py' + this.contents.padding.y : '');
      }
    },
    containerClassArray: {
      get: function get() {
        return [this.contents.fullWidth ? '' : 'container', 'py' + this.contents.padding.y];
      }
    },
    gridClass: {
      get: function get() {
        return 'grid grid-mx' + this.contents.layout.margin + ' grid-my' + this.contents.layout.margin + ' grid-1-' + this.contents.layout.s + ' grid-1-' + this.contents.layout.m + '-m grid-1-' + this.contents.layout.l + '-l';
      }
    },
    gridClassArray: {
      get: function get() {
        return ['grid', 'grid-mx' + this.contents.layout.margin, 'grid-my' + this.contents.layout.margin, 'grid-1-' + this.contents.layout.s, 'grid-1-' + this.contents.layout.m + '-m', 'grid-1-' + this.contents.layout.l + '-l'];
      }
    }
  },
  methods: {
    /**
     各コンポーネントに付与するIDを返す関数
     */
    componentId: function componentId(that) {
      return that.component ? that.component.meta.file + '-' + that._uid : that.meta.file + '-' + that._uid;
    },

    /**
     * uuid生成関数
     *
     * @see https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
     */
    uuidv4: function uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    },

    /**
     * 文字色／背景色のインラインスタイルを取得する関数
     */
    getThemeInlineStyle: function getThemeInlineStyle(prop, type) {
      return prop + ': rgba(' + this.themes.colors[type].rgba.r + ', ' + this.themes.colors[type].rgba.g + ', ' + this.themes.colors[type].rgba.b + ', ' + this.themes.colors[type].rgba.a + ')';
    },

    /**
     * 引数で与えられるIDの固定ページを返す関数
     */
    getPageById: function getPageById(id) {
      return this.pages.find(function (page) {
        return page.id === id;
      });
    },

    /**
     * 引数で与えられるIDの固定ページの子ページを返す関数
     */
    getSubPagesById: function getSubPagesById(id) {
      return this.pages.filter(function (page) {
        return page.parent === id && page.status === 'publish';
      });
    },

    /**
     * 適用ボタンを押すとthis.components.contentsからHTMLとCSSを
     * 生成してupdateイベントを発火する
     *
     * 適用ボタンを押すとthis.component.htmlとthis.component.cssを更新する
     */
    updateComponent: function updateComponent() {
      if (false) console.log('Running updateComponent of ' + this.name + '...');

      this.component.html = this.generateHtml(this.component.contents);
      this.component.css = this.generateCss(this.component.contents);
      this.$emit('update', { component: this.component, newPosition: this.newPosition });
      this.isEditing = false;
    },

    updateComponentUid: function updateComponentUid() {
      /**
       * this._uid は vue でコンポーネントが生成された際に発行される。
       * この値は発行時にユニークであるため、あとでコンポーネントが追加されたり
       * コンポーネント入れ替え時に新規に発行されても、最初に発行された this._uid とは被らない（はず）。
       * updateComponentUid が呼び出されたらイベントバスで uid-updated イベントを発火して、
       * this.component._uid に this._uid を代入して最新の this._uid をコンポーネント内に保持する
       *
       */
      if (this.component._uid !== this._uid) {
        if (false) console.log('%c_uid has been changed: ' + this.component._uid + ' -> ' + this._uid, 'color:blue');
        this.bus.$emit('uid-updated', this);
        this.component._uid = this._uid;
        if (false) console.log('%c_uid has been updated: this.component._uid = ' + this.component._uid, 'color:teal');
      }
    },

    updateComponentAndUid: function updateComponentAndUid() {
      this.updateComponentUid();
      this.updateComponent();
    },

    /**
     * コンポーネント削除用のdeleteイベントを発火する
     */
    deleteComponent: function deleteComponent() {
      this.$emit('delete');
      this.isEditing = false;
    }
  },
  /**
   * コンポーネント生成時にHTMLとCSSを生成してupdateイベントを発火する
   */
  created: function created() {
    if (!this.component._uid) this.component._uid = this._uid;
    if (this.component.uid) delete this.component.uid;
    this.updateComponent();
  },
  /**
   * コンポーネントマウント時にmountedイベントを発火する
   */
  mounted: function mounted() {
    this.$emit('mounted');
    this.bus.$on('update-child', this.updateComponentAndUid);
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__ = __webpack_require__(455);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__ = __webpack_require__(461);
function injectStyle (ssrContext) {
  __webpack_require__(459)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e0f36de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MimicAmpImg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0f36de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MimicAmpImg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLinks_vue__ = __webpack_require__(618);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fbd416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLinks_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36fbd416"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectLinks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36fbd416_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectLinks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterCompany1_vue__ = __webpack_require__(820);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac7d058_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterCompany1_vue__ = __webpack_require__(1248);
function injectStyle (ssrContext) {
  __webpack_require__(1230)
}
var normalizeComponent = __webpack_require__(20)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ac7d058"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FooterCompany1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ac7d058_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterCompany1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'component-form-footer',
  methods: {
    onDelete: function onDelete() {
      this.$emit('delete');
    },
    onCancel: function onCancel() {
      this.$emit('cancel');
    },
    onUpdate: function onUpdate() {
      this.$emit('update');
    }
  }
});

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("727fe8b8", content, true, {});

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"ComponentFormFooter.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.onDelete()}}},[_vm._v("削除")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onCancel}},[_vm._v("キャンセル")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onUpdate}},[_vm._v("適用")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(601);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mimic-amp-img',
  props: ['image']
});

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(460);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("2434fe00", content, true, {});

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, ".amp-img[data-v-7e0f36de]{display:block;width:100%;position:relative;overflow:hidden!important}.amp-img-sizer[data-v-7e0f36de]{display:block!important}.amp-img-content[data-v-7e0f36de]{display:block;margin:auto;border:none!important;padding:0!important;width:0;max-width:100%;min-width:100%;height:0;max-height:100%;min-height:100%;position:absolute;top:0;left:0;right:0;bottom:0}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/mimic-amp/MimicAmpImg.vue"],"names":[],"mappings":"AAsBA,0BACE,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,yBAA4B,CAC7B,AACD,gCACI,uBAA0B,CAC7B,AACD,kCACI,cAAe,AACf,YAAa,AACb,sBAAwB,AACxB,oBAAsB,AACtB,QAAS,AACT,eAAgB,AAChB,eAAgB,AAChB,SAAU,AACV,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,QAAU,CACb","file":"MimicAmpImg.vue","sourcesContent":["/**\n *\n * Layout\n *\n */\n/**\n * Columns\n */\n/**\n * Component\n */\n/**\n *\n * Application specific variables\n *\n */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Menu\n--------------------------*/\n.amp-img[data-v-7e0f36de] {\n  display: block;\n  width: 100%;\n  position: relative;\n  overflow: hidden !important;\n}\n.amp-img-sizer[data-v-7e0f36de] {\n    display: block !important;\n}\n.amp-img-content[data-v-7e0f36de] {\n    display: block;\n    margin: auto;\n    border: none !important;\n    padding: 0 !important;\n    width: 0;\n    max-width: 100%;\n    min-width: 100%;\n    height: 0;\n    max-height: 100%;\n    min-height: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amp-img"},[_c('div',{staticClass:"amp-img-sizer",style:('padding-top:' + _vm.image.height / _vm.image.width * 100 + '%')}),_vm._v(" "),_c('img',{staticClass:"amp-img-content",attrs:{"src":_vm.image.src}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(464),
    getRawTag = __webpack_require__(620),
    objectToString = __webpack_require__(621);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(454);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 465:
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(602),
    isLength = __webpack_require__(604);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(69)))

/***/ }),

/***/ 602:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(463),
    isObject = __webpack_require__(457);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 603:
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 604:
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'select-links',
  props: {
    value: {
      type: Array
    },
    limit: {
      type: Number,
      default: 6
    }
  },
  computed: {
    pages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/all'];
      }
    },
    publishedPages: {
      get: function get() {
        return this.$store.getters['wordpress/pages/published'];
      }
    }
  },
  methods: {
    onChange: function onChange(newValue) {
      this.$emit('input', newValue);
    }
  }
});

/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(464);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 626:
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(701);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("a098fdce", content, true, {});

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SelectLinks.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"width-100",attrs:{"multiple":_vm.limit > 1,"multiple-limit":_vm.limit,"value-key":"link","value":_vm.value,"placeholder":"固定ページから選択"},on:{"change":_vm.onChange}},[_vm._l((_vm.publishedPages),function(page){return [_c('el-option',{key:page.link,staticClass:"el-opp",attrs:{"label":page.title.rendered,"value":page.id}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_chunk__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_chunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_chunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mixins_ComponentBase__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_mimic_amp_MimicAmpImg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_forms_SelectLinks__ = __webpack_require__(136);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'footer-company-1',
  components: {
    'mimic-amp-img': __WEBPACK_IMPORTED_MODULE_2__components_mimic_amp_MimicAmpImg__["default"],
    'select-links': __WEBPACK_IMPORTED_MODULE_3__components_forms_SelectLinks__["default"]
  },
  data: function data() {
    return {
      labelWidth: '15em'
    };
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__components_mixins_ComponentBase__["default"]],
  computed: {
    logo: function logo() {
      return this.$store.getters['wordpress/settings/logo'];
    },
    contact: function contact() {
      return this.$store.getters['wordpress/settings/contact'];
    },
    owner: function owner() {
      return this.$store.getters['wordpress/settings/owner'];
    },
    fullAddress: function fullAddress() {
      return this.$store.getters['wordpress/settings/fullAddress'];
    },
    chunkLength: function chunkLength() {
      return Math.ceil(this.publishedPages.length / 4);
    },
    chunksPages: function chunksPages() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash_chunk___default()(this.publishedPages, this.chunkLength);
    }
  },
  methods: {
    /**
     * コンポーネントのHTMLを生成
     */
    generateHtml: function generateHtml(contents) {
      var _this = this;

      var infoLinks = '';
      contents.linkIds.forEach(function (id) {
        if (!_this.getPageById(id)) return;

        infoLinks += '<a class="footer-info-link theme-accent-color theme-accent-border-color theme-accent-bg-color-hover" href="' + _this.getPageById(id).link + '">' + _this.getPageById(id).title.rendered + '</a>';
      });

      var facebook = this.settings.facebook && this.settings.facebook.id ? '<a class="footer-info-sns" href="https://www.facebook.com/' + this.settings.facebook.id + '" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>' : '';
      var twitter = this.settings.twitter && this.settings.twitter.owner ? '<a class="footer-info-sns" href="https://twitter.com/' + this.settings.twitter.owner + '" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>' : '';
      var instagram = this.settings.instagram && this.settings.instagram.id ? '<a class="footer-info-sns" href="https://www.instagram.com/' + this.settings.instagram.id + '" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>' : '';
      var youtube = this.settings.youtube && this.settings.youtube.channelId ? '<a class="footer-info-sns" href="https://www.youtube.com/channel/' + this.settings.youtube.channelId + '" target="_blank"><i class="fa fa-youtube" aria-hidden="true"></i></a>' : '';

      var html = '\n      <footer class="footer theme-base-bg-color">\n        <nav class="footer-nav theme-main-bg-color">\n          <div class="footer-nav-inner">getNavListType1</div>\n        </nav>\n        <div class="footer-info">\n          <div class="footer-info-inner flex column-reverse justify-between items-center row-m">\n            <div class="footer-info-address">\n              <a class="footer-info-a" href="' + this.url + '">\n                <amp-img width="' + this.logo.width + '" height="' + this.logo.height + '" layout="responsive" src="' + this.logo.src + '" alt="' + this.settings.site.owner + '\u30ED\u30B4\u753B\u50CF" attribution="' + this.settings.site.owner + ' All Rights Reserved."><p fallback>' + this.owner + '</p>\n                </amp-img>\n              </a>\n              <p class="footer-info-p">' + this.fullAddress + '</p>\n              <p class="footer-info-p">TEL\uFF1A' + this.contact.tel + ' FAX\uFF1A' + this.contact.fax + '</p>\n              <p class="footer-info-p">e-mail\uFF1A' + this.contact.email + '</p>\n            </div>\n            <div class="footer-info-links">\n              ' + infoLinks + '\n              <div class="footer-info-sns-wrapper flex justify-center items-center">\n                ' + facebook + '\n                ' + twitter + '\n                ' + instagram + '\n                ' + youtube + '\n              </div>\n            </div>\n          </div>\n        </div>\n        <div class="footer-copyright theme-accent-bg-color">\n          <p class="footer-copyright-p">\xA9 ' + this.owner + ' All Rights Reserved.</p>\n        </div>\n      </footer>';
      return html.replace(/>\s+</g, '><').replace(/(\r\n|\n|\r)/gm, '').replace(/^\s+|\s+$/g, '');
    },
    /**
     * コンポーネントのCSSを生成
     */
    generateCss: function generateCss(contents) {
      var layout = __webpack_require__(1239)("./" + this.meta.file + '.scss');
      var theme = '';
      return { layout: layout, theme: theme };
    }
  },
  created: function created() {
    var _this2 = this;

    // 固定ページが見つからなければcontents.linkIdsから削除する
    this.component.contents.linkIds = this.component.contents.linkIds.filter(function (id) {
      return _this2.getPageById(id);
    });
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/14.66656b24708b81e93162.js